var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5723 13.1429H22.9952C24.3514 13.1429 25.0219 14.7886 24.0618 15.7486L17.0676 22.7429C16.4733 23.3371 15.5133 23.3371 14.919 22.7429L7.92471 15.7486C6.96471 14.7886 7.65042 13.1429 9.00661 13.1429H11.4295V5.52381C11.4295 4.68571 12.1152 4 12.9533 4H19.0485C19.8866 4 20.5723 4.68571 20.5723 5.52381V13.1429ZM6.85731 29.9047C6.01921 29.9047 5.3335 29.219 5.3335 28.3809C5.3335 27.5428 6.01921 26.8571 6.85731 26.8571H25.143C25.9811 26.8571 26.6668 27.5428 26.6668 28.3809C26.6668 29.219 25.9811 29.9047 25.143 29.9047H6.85731Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.656068a1.svg";
export { ForwardRef as ReactComponent };